import { Component, Input } from '@angular/core';
import { UsersService } from "../../../../services/users.service";

@Component({
    selector: 'app-device-info',
    templateUrl: './device-info.component.html',
    styleUrls: ['./device-info.component.css'],
    standalone: false
})
export class DeviceInfoComponent {
  @Input() trackingMode: boolean;

  constructor(public usersService: UsersService) {
  }
}
